module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/gaming_header.39bb3ef4.png";